import React from 'react';

import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../redux/actions'; //Import your actions

import '../styles/lookup.scss';
// import 'materialize-css';
import MapView from './MapView';
import LocationEquipmentList from './LocationEquipmentList';
import ServiceLogModal from './ServiceLogModal';
// import QuoteGeneratorModal from './QuoteGeneratorModal';
import AccountReviewModal from './AccountReviewModal';
import SystemReviewModal from './SystemReviewModal';
import Search from './Search';
import Dropzone, {useDropzone} from 'react-dropzone';
import { useSpring, animated } from '@react-spring/web'
import { useDrag } from '@use-gesture/react'
import MailFileModal from './MailFileModal';
import FilePreviewModal from './FilePreviewModal';
import RecipientSelect from '../components/RecipientSelect';
import WastewaterPricing from './WastewaterPricing';
import InfoCard from './InfoCard';
import LookupHero from './LookupHero';
import OperatorsCard from './OperatorsCard';
import ReportTemplatesCard from './ReportTemplatesCard';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { Chart } from 'chart.js/auto';
import Checkbox from '@mui/material/Checkbox';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DescriptionIcon from '@mui/icons-material/Description';
import HvacIcon from '@mui/icons-material/Hvac';
import BookIcon from '@mui/icons-material/Book';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ScienceIcon from '@mui/icons-material/Science';
import ShareIcon from '@mui/icons-material/Share';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import FileIcon from '@mui/icons-material/FilePresent';
import CancelIcon from '@mui/icons-material/Cancel';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LinkIcon from '@mui/icons-material/LinkRounded';
import GradingIcon from '@mui/icons-material/Grading';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SendIcon from '@mui/icons-material/Send';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import PlaceIcon from '@mui/icons-material/Place';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const reportRangeStatus = (inRange) => {
  if (inRange === true) {
    return { key: 'ok', label: 'In range', Icon: CheckCircleOutlineIcon };
  }
  if (inRange === false) {
    return { key: 'attention', label: 'Attention', Icon: ErrorOutlineIcon };
  }
  return { key: 'empty', label: 'No tests', Icon: RemoveCircleOutlineIcon };
};

const AnimatedTableRow = animated(TableRow);

const SwipeableRow = ({ children, onDelete, onClick, onMouseEnter, onMouseLeave }) => {
  const [{ x }, api] = useSpring(() => ({ x: 0 }));

  const bind = useDrag(({ active, movement: [mx], velocity: [vx], tap }) => {
    if (tap) {
      onClick?.();
      return;
    }

    const trigger = vx > 0.5 || mx > 100;
    if (!active && trigger) {
      onDelete();
      api.start({ x: 0 });
    } else {
      api.start({ x: active ? mx : 0 });
    }
  });

  const child = React.Children.only(children);
  const { children: rowChildren, style, sx, className, ...rowProps } = child.props;

  return (
    <AnimatedTableRow
      {...rowProps}
      {...bind()}
      className={className}
      sx={sx}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        ...(style || {}),
        x,
        touchAction: 'pan-y',
        position: 'relative',
      }}
    >
      {rowChildren}
    </AnimatedTableRow>
  );
};

class AccountInfo extends React.Component {

  constructor() {
    super();

    this.onDrop = (files) => {
      this.setState({files});
    }

    this.state = {
      showServiceLogs: false,
      selectedFile: [],
      accountReviewChart: null,
      accountReviewYear: null,
      productsPage: 0,
      productsPerPage: 8,
      productSearch: '',
      ordersPage: 0,
      ordersPerPage: 10,
      quotesPage: 0,
      quotesPerPage: 10,
      tempContact: null,
      savingContact: false,
      flashingContactIds: [],
      equipmentExpanded: false,
      confirmDeleteReport: null,
      expandedReportId: null,
      reportsTab: 'history', // history | templates, in the Reports card
      deletedReportsCount: 0, // used to update the total reports counter in the card header
      resendingReportId: null, // hash_id of the report currently being resent
      resentReportIds: {}, // hash_id -> timestamp of the last successful resend (for transient confirmation)
      resendModalReport: null, // the report object whose recipient-select modal is open
      resendRecipients: [], // selected emails inside the resend modal
      showSystemReviewModal: false,
    };

    this.chart = null;
  }

  filterProducts() {
    if (!this.props.info?.products) return [];
    return this.props.info.products.filter(product => 
      product.model.toLowerCase().includes(this.state.productSearch.toLowerCase()) ||
      product.description.toLowerCase().includes(this.state.productSearch.toLowerCase())
    );
  }

  ordersSummary(orders = []) {
    if (!orders.length) return 'No orders in the past year';
    const latest = [...orders].sort((a, b) => new Date(b.submitted) - new Date(a.submitted))[0];
    return `Latest ${latest.submitted} · ${latest.items} item${latest.items === 1 ? '' : 's'}`;
  }

  productsSummary(products = []) {
    if (!products.length) return 'No products on record';
    const preview = products.slice(0, 2).map((p) => p.model).join(', ');
    return products.length > 2 ? `${preview} +${products.length - 2} more` : preview;
  }

  contactsSummary(contacts = []) {
    if (!contacts.length) return 'No contacts on file';
    const primary = contacts.find((c) => c.primary) || contacts[0];
    const name = `${primary.fname || ''} ${primary.lname || ''}`.trim();
    return contacts.length > 1 ? `${name} +${contacts.length - 1} more` : (name || primary.email || 'View contacts');
  }

  filesSummary(files = []) {
    if (!files.length) return 'No files uploaded';
    return `Latest: ${files[0].file_name}`;
  }

  equipmentSummary(equipment = []) {
    if (!equipment.length) return 'No systems on contract';
    return equipment.slice(0, 2).map((e) => e.description).join(', ');
  }

  reportsSummary(reports = [], total = 0) {
    const submitted = reports.filter((r) => r.submitted).length;
    return `${submitted} recent · ${total} total`;
  }

  createOrUpdateChart() {
    let review = {};
    this.props.info?.account_review?.forEach(d => {
      if (!review[d.year]) {
        review[d.year] = {
          revenue: 0,
          cost: 0
        }
      } 
      review[d.year].revenue += parseFloat(d.sales) || 0;
      review[d.year].cost += parseFloat(d.cost) || 0;
    });

    const ctx = document.getElementById('accountReviewChart');
    if (ctx && this.props.info?.account_review) {
      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: Object.keys(review),
          datasets: [
            {
              label: 'Cost',
              data: Object.values(review).map(r => r.cost),
              backgroundColor: '#0D74FF'
            },
            {
              label: 'Sales',
              data: Object.values(review).map(r => r.revenue),
              backgroundColor: 'rgba(54, 162, 235)'
            },
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          resizeDelay: 0,
          scales: {
            x: {
              reverse: false,
              stacked: true,
            },
            y: {
              beginAtZero: true,
            }
          },
          onClick: (event, elements) => {
            if (elements.length > 0) {
              const element = elements[0];
              const year = Object.keys(review)[element.index];
              this.setState({accountReviewYear: year});
            }
          }
        }
      });
    }
  }

  componentDidMount() {
    this.createOrUpdateChart();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.info?.account_review !== this.props.info?.account_review) {
      this.createOrUpdateChart();
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
    if (this.contactFlashTimeout) clearTimeout(this.contactFlashTimeout);
  }

  flashContacts(ids) {
    if (!ids.length) return;

    if (this.contactFlashTimeout) clearTimeout(this.contactFlashTimeout);

    this.setState({ flashingContactIds: ids });
    this.contactFlashTimeout = setTimeout(() => {
      this.setState({ flashingContactIds: [] });
      this.contactFlashTimeout = null;
    }, 1400);
  }

  saveContact(contact) {
    const existingIds = new Set((this.props.info.contacts || []).map((c) => c.id));
    const isNew = !!contact.new;
    const savedId = contact.id;

    this.setState({ savingContact: true });
    return this.props.updateContact(
      { ...contact, customer_id: this.props.info.id },
      this.props.authToken,
      (json) => {
        const flashIds = isNew
          ? (json?.contacts || []).filter((c) => !existingIds.has(c.id)).map((c) => c.id)
          : [savedId];

        this.setState({ tempContact: null }, () => {
          this.flashContacts(flashIds);
        });
      }
    )?.finally?.(() => {
      this.setState({ savingContact: false });
    });
  }

  newContact(info = {}, submit = false, onSuccess = () => {}) {
    let infoCopy = {...this.props.info};

    let id = Date.now();

    let newContact = {
      id: id, 
      fname: '',
      lname: '',
      title: '',
      phone: '',
      email: '',
      reports: false,
      primary: false,
      new: true,
      customer_id: this.props.info.id,
      ...info
    };

    infoCopy.contacts.push(newContact);

    this.props.updateLookupInfo(infoCopy);

    if (submit) {
      this.props.updateContact(newContact, this.props.authToken, onSuccess);
    } else {
      this.setState({tempContact: newContact});
    }
  }

  newReport() {
    this.props.createReport(
      this.props.info.id, 
      'sr', 
      null, 
      this.props.authToken, 
      (newReportUrl) => {window.location.href = `/reports/edit?${newReportUrl}`}
    );
  }

  handleFileSubmit(file) {
    if (file) {
      // Validate file size
      const maxSize = 25 * 1024 * 1024; // 25MB

      if (file.size > maxSize) {
        console.error('File is too large. Maximum size is 25MB.');
        return;
      }

      const formData = new FormData();
      formData.append('file', file);
      formData.append('customer_id', this.props.info.id);
      formData.append('enctype', 'multipart/form-data');

      this.props.fileUpload(this.props.authToken, formData).then(() => {
        console.log('file uploaded');
      });
    }
  };  

  deleteFile(fileId) {
    this.props.deleteFile(this.props.authToken, fileId);
  }

  newQuote() {
    this.props.newQuote(
      this.props.authToken, 
      this.props.info.id,
      !this.props.quotableProducts?.length > 0
    );
  }

  openReport(e, report) {
    e?.stopPropagation();
    if (report.submitted) {
      window.open(report.url, '_blank', 'noopener,noreferrer');
    } else {
      window.open(`/reports/edit?${report.id}`, '_blank', 'noopener,noreferrer');
    }
  }

  editReport(e, report) {
    e?.stopPropagation();
    window.open(`/reports/edit?${report.id}`, '_blank', 'noopener,noreferrer');
  }

  // Opens the recipient-select modal pre-filled with the report's stored
  // recipients. Actual send happens from confirmResendReport on submit.
  handleResendReport(e, report) {
    e?.stopPropagation();
    if (this.state.resendingReportId) return;

    this.setState({
      resendModalReport: report,
      resendRecipients: [...(report.recipients || [])],
    });
  }

  confirmResendReport() {
    const report = this.state.resendModalReport;
    const recipients = this.state.resendRecipients;
    if (!report || recipients.length === 0) return;

    this.setState({resendingReportId: report.id});
    this.props.resendReport(
      report.id,
      this.props.authToken,
      recipients,
      () => {
        this.setState({
          resendingReportId: null,
          resendModalReport: null,
          resendRecipients: [],
          resentReportIds: {...this.state.resentReportIds, [report.id]: Date.now()},
        });
        setTimeout(() => {
          const next = {...this.state.resentReportIds};
          delete next[report.id];
          this.setState({resentReportIds: next});
        }, 3000);
      },
      () => this.setState({resendingReportId: null})
    );
  }

  render() {
    return this.props.info?.type === 'account' ? (
      <div className="info-container">
        <LookupHero
          title={this.props.info.name}
          map={this.props.info.addresses?.length ? (
            <div className="map-container lookup-hero-map-container">
              <MapView
                addresses={this.props.info.addresses}
                equipment={this.props.info.equipment}
                centerOffsetX={110}
              />
            </div>
          ) : null}
          meta={(
            <>
              <span>Manager: <b>{this.props.info.manager}</b></span>
              <span>
                Technician{this.props.info.technicians.length === 1 ? '' : 's'}:{' '}
                <b>{this.props.info.technicians.join(', ')}</b>
              </span>
            </>
          )}
          actions={(
            <>
              <button className="button view-log" onClick={() => this.setState({ showServiceLogs: true })}>
                <BookIcon className="button-icon" />
                <b>Service Log</b>
              </button>
              {this.props.info.contract ? (
                <a href={this.props.info.contract} className="button view-contract" target="_blank" rel="noopener noreferrer">
                  <b>View Contract</b>
                  <DescriptionIcon className="button-icon" />
                </a>
              ) : null}
            </>
          )}
        />

        {this.props.info.addresses ? (
          <InfoCard
            id="account-map"
            icon={<PlaceIcon />}
            title="Locations"
            count={this.props.info.addresses.length}
            subtitle="Addresses and equipment map"
            summary={`${this.props.info.addresses.length} address${this.props.info.addresses.length === 1 ? '' : 'es'} · ${this.props.info.equipment?.length || 0} systems`}
          >
            <div className="map-container">
              <MapView addresses={this.props.info.addresses} equipment={this.props.info.equipment} />
            </div>
            <LocationEquipmentList
              addresses={this.props.info.addresses}
              equipment={this.props.info.equipment}
              canEdit={!!this.props.user?.admin}
              employees={this.props.info.employees || []}
              onSave={(changes) => this.props.updateEquipment(changes, this.props.authToken).then((json) => (
                // Show the saved name and technician, and the account's refreshed technician list.
                this.props.updateLookupInfo({
                  ...this.props.info,
                  equipment: this.props.info.equipment.map((item) => (item.id === json.equipment.id ? { ...item, ...json.equipment } : item)),
                  technicians: json.technicians,
                })
              ))}
            />
          </InfoCard>
        ) : null}

        {this.props.info.account_review ? (
          <InfoCard
            id="account-review"
            icon={<GradingIcon />}
            title="Account review"
            subtitle="Revenue and cost by year"
            summary="Click a bar to view yearly breakdown"
            onOpenChange={(open) => {
              if (open) {
                requestAnimationFrame(() => this.createOrUpdateChart());
              } else if (this.chart) {
                this.chart.destroy();
                this.chart = null;
              }
            }}
          >
            <canvas id="accountReviewChart"></canvas>
          </InfoCard>
        ) : null}

        {this.props.info.reports ? (
          <InfoCard
            id="recent-reports"
            icon={<DescriptionIcon />}
            title="Reports"
            count={this.props.info.total_report_count - this.state.deletedReportsCount}
            subtitle="Recent report activity"
            scrollable={true}
            summary={this.reportsSummary(this.props.info.reports, this.props.info.total_report_count - this.state.deletedReportsCount)}
            onOpenChange={(open) => { if (open) this.setState({reportsTab: 'history'}); }}
          >
            {/* Templates are managed by account managers and admins; everyone else just sees the history. */}
            {this.props.user?.managesOperators && (
              <div className="info-card-tabs" role="tablist" aria-label="Reports">
                {[
                  ['history', 'Report history'],
                  ['templates', 'Report templates'],
                ].map(([tab, label]) => (
                  <button
                    key={tab}
                    type="button"
                    role="tab"
                    aria-selected={this.state.reportsTab === tab}
                    className={`info-card-tab${this.state.reportsTab === tab ? ' active' : ''}`}
                    onClick={() => this.setState({reportsTab: tab})}
                  >
                    {label}
                  </button>
                ))}
              </div>
            )}

            {this.props.user?.managesOperators && this.state.reportsTab === 'templates' ? (
              <ReportTemplatesCard customerId={this.props.info.id} />
            ) : (
            <>
              <ul className="lookup-reports-list">
                {this.props.info.reports?.map((report) => {
                  const isExpanded = this.state.expandedReportId === report.id;
                  const recipients = report.recipients || [];
                  const isDraft = !report.submitted;
                  const rangeStatus = reportRangeStatus(report.inRange);
                  const status = isDraft
                    ? { key: 'draft', label: 'Draft', Icon: null }
                    : rangeStatus;
                  const StatusIcon = status.Icon;
                  const meta = [
                    report.submitted ? `Submitted ${report.submitted}` : `Started ${report.created}`,
                    report.completion?.tests > 0
                      ? `${report.completion.tests} test${report.completion.tests === 1 ? '' : 's'}`
                      : null,
                    report.completion?.notes > 0
                      ? `${report.completion.notes} note${report.completion.notes === 1 ? '' : 's'}`
                      : null,
                  ].filter(Boolean).join(' · ');

                  return (
                    <li key={'report-'+report.id} className="lookup-reports-item">
                      <div
                        role="button"
                        tabIndex={0}
                        className={[
                          'lookup-report-row',
                          `lookup-report-row--${status.key}`,
                          isExpanded ? 'expanded' : '',
                          this.state.confirmDeleteReport === report.id ? 'confirm-delete' : '',
                        ].filter(Boolean).join(' ')}
                        onClick={() => this.setState({
                          expandedReportId: isExpanded ? null : report.id,
                          confirmDeleteReport: null,
                        })}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            this.setState({
                              expandedReportId: isExpanded ? null : report.id,
                              confirmDeleteReport: null,
                            });
                          }
                        }}
                      >
                        <div className="lookup-report-main">
                          <div className="lookup-report-title-line">
                            <span className="lookup-report-title">{report.title}</span>
                            {report.author && (
                              <span className="lookup-report-author">by {report.author}</span>
                            )}
                            {report.edited_after_submit && (
                              <span className="lookup-report-edited" title="Edited after submission">Edited</span>
                            )}
                          </div>
                          {meta ? <span className="lookup-report-meta">{meta}</span> : null}
                        </div>

                        <span className={`lookup-report-status lookup-report-status--${status.key}`}>
                          {StatusIcon ? (
                            <StatusIcon className="lookup-report-status-icon" aria-hidden="true" />
                          ) : null}
                          {status.label}
                        </span>

                        <ExpandMoreIcon
                          className={`lookup-report-chevron${isExpanded ? ' expanded' : ''}`}
                          aria-hidden="true"
                        />
                      </div>

                      {isExpanded && (
                        <div className="lookup-report-detail">
                          <div className="report-detail-actions">
                            {this.state.confirmDeleteReport === report.id ? (
                              <>
                                <button
                                  className="report-detail-button delete-confirm"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.props.destroyReport(report.id, this.props.authToken, () => {
                                      this.setState({
                                        deletedReportsCount: this.state.deletedReportsCount + 1,
                                        expandedReportId: null,
                                        confirmDeleteReport: null,
                                      });
                                    });
                                  }}
                                >
                                  <DeleteIcon /> Confirm Delete
                                </button>
                                <button
                                  className="report-detail-button cancel"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({confirmDeleteReport: null});
                                  }}
                                >
                                  <CancelIcon /> Nevermind
                                </button>
                              </>
                            ) : (
                              <>
                                {report.submitted && (
                                  <button
                                    className="report-detail-button view"
                                    onClick={(e) => this.openReport(e, report)}
                                  >
                                    <VisibilityIcon /> View Report
                                  </button>
                                )}
                                <button
                                  className="report-detail-button edit"
                                  onClick={(e) => this.editReport(e, report)}
                                >
                                  <EditIcon /> Edit Report
                                </button>
                                {report.submitted && (
                                  <button
                                    className={`report-detail-button resend ${this.state.resentReportIds[report.id] ? 'resent' : ''}`}
                                    onClick={(e) => this.handleResendReport(e, report)}
                                    disabled={this.state.resendingReportId === report.id}
                                  >
                                    {this.state.resentReportIds[report.id] ? (
                                      <><CheckCircleIcon /> Sent!</>
                                    ) : this.state.resendingReportId === report.id ? (
                                      <><SendIcon /> Sending...</>
                                    ) : (
                                      <><SendIcon /> Resend Report</>
                                    )}
                                  </button>
                                )}
                                {isDraft && (
                                  <button
                                    className="report-detail-button delete"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.setState({confirmDeleteReport: report.id});
                                    }}
                                  >
                                    <DeleteIcon /> Delete
                                  </button>
                                )}
                              </>
                            )}
                          </div>

                          <div className="report-detail-section">
                            <div className="report-detail-label">
                              <EmailIcon className="report-detail-label-icon" />
                              Recipients
                            </div>
                            {recipients.length > 0 ? (
                              <div className="report-detail-recipients">
                                {recipients.map((email) => (
                                  <a
                                    key={email}
                                    className="report-detail-recipient"
                                    href={`mailto:${email}`}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {email}
                                  </a>
                                ))}
                              </div>
                            ) : (
                              <div className="report-detail-empty">No recipients on file</div>
                            )}
                          </div>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>

              {(this.props.info.total_report_count > this.props.info.reports.length) && (
                <button 
                  className="load-more-btn"
                  onClick={() => this.props.fetchMoreReports(
                    this.props.authToken, 
                    this.props.info.id, 
                    this.props.info.reports.length
                  )}
                  disabled={this.props.loading}
                >
                  {this.props.loading ? 'Loading...' : 'Load More Reports'}
                </button>
              )}
              
              <div className="add-new" onClick={() => this.newReport()}>
                <AddIcon />
                <span>Create New Report</span>
              </div>
            </>
            )}
          </InfoCard>
        ) : null}


        {this.props.info.products ? (
          <InfoCard
            id="products-ordered"
            icon={<ScienceIcon />}
            title="Products used"
            count={this.props.info.products.length}
            subtitle={`At ${this.props.info.name}`}
            summary={this.productsSummary(this.props.info.products)}
          >
              <div style={{ 
                padding: '0 0 5px 0',
                display: 'flex',
                alignItems: 'center'
              }}>
                <input
                  type="text"
                  placeholder={`Search products used at ${this.props.info.name}`}
                  value={this.state.productSearch}
                  onChange={(e) => this.setState({ productSearch: e.target.value, productsPage: 0 })}
                  className="search-input"
                />
              </div>

              <TableContainer component={Paper} className="product-table-container">
                <Table className="product-table" aria-label="simple table" size="medium">
                  <TableBody>
                    {this.filterProducts()
                      .slice(
                        this.state.productsPage * this.state.productsPerPage,
                        (this.state.productsPage + 1) * this.state.productsPerPage
                      )
                      .map((row) => (
                        <TableRow
                          key={'product-'+row.id}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 }, '& td': { padding: '10px 16px' } }}
                          onClick={() => {this.props.fetchInfo(this.props.authToken, row.id, 'p', null)}}
                        >
                          <TableCell align="left" className="product-model-cell" size="medium">
                            <b>{row.model}</b>
                          </TableCell>
                          <TableCell align="left" className="product-description-cell" title={row.description}>
                            <span className="product-description-text">{row.description}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}>
                <button 
                  onClick={() => this.setState({ productsPage: Math.max(0, this.state.productsPage - 1) })}
                  disabled={this.state.productsPage === 0}
                  style={{ marginRight: '1rem' }}
                >
                  Previous
                </button>
                <span>
                  Page {this.state.productsPage + 1} of{' '}
                  {Math.ceil(this.filterProducts().length / this.state.productsPerPage)}
                </span>
                <button 
                  onClick={() => this.setState({ 
                    productsPage: Math.min(
                      Math.ceil(this.filterProducts().length / this.state.productsPerPage) - 1,
                      this.state.productsPage + 1
                    )
                  })}
                  disabled={this.state.productsPage >= Math.ceil(this.filterProducts().length / this.state.productsPerPage) - 1}
                  style={{ marginLeft: '1rem' }}
                >
                  Next
                </button>
              </div>
          </InfoCard>
        ) : null}
        
        {this.props.info.orders ? (
          <InfoCard
            id="orders-submitted"
            icon={<ShoppingCartIcon />}
            title="Orders"
            count={this.props.info.orders.length}
            subtitle={`Since ${new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toLocaleDateString()}`}
            summary={this.ordersSummary(this.props.info.orders)}
          >
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table" size="medium">
                  <TableBody>
                    {[...this.props.info.orders]
                      .sort((a, b) => new Date(b.submitted) - new Date(a.submitted))
                      .slice(
                        this.state.ordersPage * this.state.ordersPerPage,
                        (this.state.ordersPage + 1) * this.state.ordersPerPage
                      )
                      .map((row) => (
                        <TableRow
                          key={'order-'+row.url}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          onClick={() => window.open(row.url, '_blank', 'noopener,noreferrer')}
                        >
                          <TableCell align='left'>Placed by: <b>{row.placed_by}</b></TableCell>
                          <TableCell align='center'>Items ordered: <b>{row.items}</b></TableCell>
                          <TableCell align='right'>Submitted: <b>{row.submitted}</b></TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}>
                <button 
                  onClick={() => this.setState({ ordersPage: Math.max(0, this.state.ordersPage - 1) })}
                  disabled={this.state.ordersPage === 0}
                  style={{ marginRight: '1rem' }}
                >
                  Previous
                </button>
                <span>
                  Page {this.state.ordersPage + 1} of{' '}
                  {Math.ceil(this.props.info.orders.length / this.state.ordersPerPage)}
                </span>
                <button 
                  onClick={() => this.setState({ 
                    ordersPage: Math.min(
                      Math.ceil(this.props.info.orders.length / this.state.ordersPerPage) - 1,
                      this.state.ordersPage + 1
                    )
                  })}
                  disabled={this.state.ordersPage >= Math.ceil(this.props.info.orders.length / this.state.ordersPerPage) - 1}
                  style={{ marginLeft: '1rem' }}
                >
                  Next
                </button>
              </div>
          </InfoCard>
        ) : null}
        
        {this.props.info.contacts ? (
          <InfoCard
            id="account-contacts"
            icon={<ContactMailIcon />}
            title="Contacts"
            count={this.props.info.contacts.length}
            subtitle="Account contacts"
            summary={this.contactsSummary(this.props.info.contacts)}
          >
              <TableContainer component={Paper} className="contact-table-container">
                <Table className="contact-table" aria-label="account contacts" size="medium">
                  <TableHead>
                    <TableRow>
                      <TableCell>Contact</TableCell>
                      <TableCell>Email / Phone</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.props.info.contacts.map((row) => {
                      const isEditing = this.state.tempContact?.id === row.id;
                      const displayName = `${row.fname || ''} ${row.lname || ''}`.trim();
                      const flashingSet = new Set(this.state.flashingContactIds);

                      return (
                        <TableRow
                          key={`contact-${row.id}`}
                          className={[
                            isEditing ? 'contact-row-editing' : '',
                            flashingSet.has(row.id) ? 'contact-row-flash' : '',
                          ].filter(Boolean).join(' ')}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell>
                            {isEditing ? (
                              <div className="contact-edit-fields">
                                <input
                                  className="contact-input"
                                  placeholder="Name"
                                  value={this.state.tempContact?.name || ''}
                                  onChange={(e) => this.setState({
                                    tempContact: { ...this.state.tempContact, name: e.target.value },
                                  })}
                                />
                                <input
                                  className="contact-input"
                                  placeholder="Title"
                                  value={this.state.tempContact?.title || ''}
                                  onChange={(e) => this.setState({
                                    tempContact: { ...this.state.tempContact, title: e.target.value },
                                  })}
                                />
                              </div>
                            ) : (
                              <>
                                <div className="contact-cell-primary">
                                  {displayName || '—'}
                                  {row.primary ? (
                                    <span className="contact-primary-badge">Primary</span>
                                  ) : null}
                                </div>
                                {row.title ? (
                                  <div className="contact-cell-secondary">{row.title}</div>
                                ) : null}
                              </>
                            )}
                          </TableCell>

                          <TableCell>
                            {isEditing ? (
                              <div className="contact-edit-fields">
                                <input
                                  className="contact-input"
                                  placeholder="Email"
                                  value={this.state.tempContact?.email || ''}
                                  onChange={(e) => this.setState({
                                    tempContact: { ...this.state.tempContact, email: e.target.value },
                                  })}
                                />
                                <input
                                  className="contact-input"
                                  placeholder="Phone"
                                  value={this.state.tempContact?.phone || ''}
                                  onChange={(e) => this.setState({
                                    tempContact: { ...this.state.tempContact, phone: e.target.value },
                                  })}
                                />
                              </div>
                            ) : (
                              <>
                                <div className="contact-cell-primary">
                                  {row.email ? (
                                    <a href={`mailto:${row.email}`} className="contact-email-link">
                                      {row.email}
                                    </a>
                                  ) : (
                                    <span className="contact-empty">—</span>
                                  )}
                                </div>
                                {row.phone ? (
                                  <div className="contact-cell-secondary">{row.phone}</div>
                                ) : null}
                              </>
                            )}
                          </TableCell>

                          <TableCell align="right">
                            {isEditing ? (
                              <div className="contact-row-actions">
                                <div className="contact-btn-wrap">
                                  {this.state.savingContact && (
                                    <div className="saving-flash shown" aria-hidden="true" />
                                  )}
                                  <button
                                    type="button"
                                    className="contact-btn contact-btn-primary"
                                    disabled={this.state.savingContact}
                                    onClick={() => {
                                      const name = this.state.tempContact?.name?.trim() || '';
                                      const [fname = '', ...lname] = name.split(' ');
                                      this.saveContact({
                                        ...this.state.tempContact,
                                        fname,
                                        lname: lname.join(' '),
                                      });
                                    }}
                                  >
                                    <DoneIcon />
                                    <span>{this.state.savingContact ? 'Saving...' : 'Save'}</span>
                                  </button>
                                </div>
                                <button
                                  type="button"
                                  className="contact-btn contact-btn-danger"
                                  disabled={this.state.savingContact}
                                  onClick={() => this.props.updateContact(
                                    { ...row, _destroy: true, customer_id: this.props.info.id },
                                    this.props.authToken,
                                    () => this.setState({ tempContact: null })
                                  )}
                                >
                                  <DeleteIcon />
                                  <span>Delete</span>
                                </button>
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="contact-edit-btn"
                                disabled={!!this.state.tempContact}
                                onClick={() => this.setState({
                                  tempContact: { name: displayName, ...row },
                                })}
                              >
                                <EditIcon />
                                <span>Edit</span>
                              </button>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              <div className="add-new" onClick={() => this.newContact()}>
                <AddIcon />
                <span>Add new contact</span>
              </div>
          </InfoCard>
        ) : null}

        {this.props.user?.managesOperators ? (
          <OperatorsCard customerId={this.props.info.id} />
        ) : null}

        <InfoCard
          id="account-files"
          icon={<FileIcon />}
          title="Files"
          count={this.props.info.files.length}
          subtitle="Uploaded documents"
          summary={this.filesSummary(this.props.info.files)}
        >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table" className="file-table">
                <TableBody>
                  {this.props.info.files.map((row) => (
                    <TableRow
                      key={'file-'+row.uploaded}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell className="file-info-container" align='left'>
                        <p className="file-info file-name">{row.file_name}</p>
                        <p className="file-info file-uploaded"> Uploaded {row.uploaded_formatted} by {row.uploaded_by}</p>
                      </TableCell>
                      {/* <TableCell align='right'>Uploaded {row.uploaded_formatted} by {row.uploaded_by}</TableCell> */}
                      <TableCell align='right' className="file-table-buttons-container">
                        <button className="preview-file-button file-table-button" title="Preview" aria-label={`Preview ${row.file_name}`} onClick={() => {
                          this.setState({previewFile: row});
                        }}>
                          <VisibilityOutlinedIcon className="cell-icon preview-file-icon" />
                        </button>

                        <button className="download-file-button file-table-button" title="Download" aria-label={`Download ${row.file_name}`} onClick={() => {
                          window.open(row.url, '_blank', 'noopener,noreferrer');
                        }}>
                          <DownloadIcon className="cell-icon download-file-icon" />
                        </button>

                        <button className="share-file-button file-table-button" title="Copy link" aria-label={`Copy link to ${row.file_name}`} onClick={() => {
                          // Implement share functionality here
                          // For example, you could copy the file link to clipboard
                          navigator.clipboard.writeText(row.url).then(() => {
                            alert('File link copied to clipboard!');
                          }, (err) => {
                            console.error('Could not copy text: ', err);
                          });
                        }}>
                          <LinkIcon className="cell-icon share-file-icon" />
                        </button>

                        <button className="email-file-button file-table-button" title="Email" aria-label={`Email ${row.file_name}`} onClick={() => {
                          this.setState({mailFile: row});
                        }}>
                          <MailOutlineIcon className="cell-icon email-file-icon" />
                        </button>

                        <button className="delete-file-button file-table-button" title="Delete" aria-label={`Delete ${row.file_name}`} onClick={() => {
                          if (window.confirm('Are you sure you want to delete this file?')) {
                            this.deleteFile(row.id);
                          }
                        }}>
                          <DeleteOutlineIcon className="cell-icon delete-file-icon" />
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer> 

            <div className="file-drop-container" onClick={(e) => {
              e.stopPropagation();
            }}>
              <Dropzone
                onDrop={(acceptedFiles, rejectedFiles) => {
                  console.log('DROPPED', acceptedFiles, rejectedFiles);
                  if (acceptedFiles.length > 0) {
                    acceptedFiles.forEach(file => {
                      this.handleFileSubmit(file);
                    })
                  }
                  if (rejectedFiles.length > 0) {
                    rejectedFiles.forEach(file => {
                      console.log('file failed to upload', file);
                      window.alert('File size exceeds 25MB limit. Please try again with a smaller file.');
                    })
                  }
                }}
                maxSize={25 * 1024 * 1024} // 25MB
              >
                {({getRootProps, getInputProps, isDragActive}) => (
                  <div {...getRootProps()} className={`file-dropzone${isDragActive ? ' active' : ''}`}>
                    <input {...getInputProps()} onChange={(e) => this.setState({selectedFile: e.target.files[0]})} />
                    <span className="file-dropzone-icon"><UploadFileIcon /></span>
                    <span className="file-dropzone-text">
                      <span className="file-dropzone-title">
                        {isDragActive
                          ? 'Drop to upload'
                          : <>Drag files here or <span className="file-dropzone-browse">browse</span></>}
                      </span>
                      <span className="file-dropzone-hint">Up to 25 MB per file</span>
                    </span>
                  </div>
                )}
              </Dropzone>
            </div>
        </InfoCard>

        <WastewaterPricing contextType="a" />
        
        {this.props.info.quotes ? (
          <InfoCard
            id="quotes"
            icon={<AttachMoneyIcon />}
            title="Quotes"
            count={this.props.info.quotes.filter(quote => quote.sent_at).length}
            subtitle={`${this.props.info.quotes.length} total`}
            summary={`${this.props.info.quotes.filter((q) => q.sent_at).length} submitted · ${this.props.info.quotes.filter((q) => !q.sent_at).length} drafts`}
          >
              {this.props.info.quotes.length > 0 ? [
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table" size="medium" className="quote-table">
                    <TableHead>
                      <TableRow>
                        {/* <TableCell>ID</TableCell> */}
                        <TableCell>Date</TableCell>
                        <TableCell>Title</TableCell>
                        <TableCell>Recipients</TableCell>
                        <TableCell>Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.props.info.quotes
                        .slice(
                          this.state.quotesPage * this.state.quotesPerPage,
                          (this.state.quotesPage + 1) * this.state.quotesPerPage
                        )
                        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                        .map((row) => (
                          <TableRow key={'quote-'+row.id} onClick={() => window.open(`https://www.proasysinc.com/quotes/show?id=${row.hash_id}`, '_blank', 'noopener,noreferrer')}>
                            {/* <TableCell>{row.id}</TableCell> */}
                            <TableCell>{new Date(row.updated_at).toLocaleDateString()}</TableCell>
                            <TableCell>{row.subject || 'No Subject'}</TableCell>
                            <TableCell>{row.recipients?.split(',').length || 0} recipient(s)</TableCell>
                            <TableCell>{row.sent_at ? 'Sent' : 'Draft'}</TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>,
                <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}>
                  <button 
                    onClick={() => this.setState({ quotesPage: Math.max(0, this.state.quotesPage - 1) })}
                    disabled={this.state.quotesPage === 0}
                    style={{ marginRight: '1rem' }}
                  >
                    Previous
                  </button>
                  <span>
                    Page {this.state.quotesPage + 1} of{' '}
                    {Math.ceil(this.props.info.quotes.length / this.state.quotesPerPage)}
                  </span>
                  <button 
                    onClick={() => this.setState({ 
                      quotesPage: Math.min(
                        Math.ceil(this.props.info.quotes.length / this.state.quotesPerPage) - 1,
                        this.state.quotesPage + 1
                      )
                    })}
                    disabled={this.state.quotesPage >= Math.ceil(this.props.info.quotes.length / this.state.quotesPerPage) - 1}
                    style={{ marginLeft: '1rem' }}
                  >
                    Next
                  </button>
                </div>
              ] : null}

              

              {/* <div className='add-new' onClick={() => this.newQuote()}>
                <AddIcon style={{color: '#0D74FF', marginRight: 50, zIndex: 1}}/>
                <span>Create New Quote</span>
              </div> */}
          </InfoCard>
        ) : null}

        {this.state.mailFile && (
          <MailFileModal 
            file={this.props.info.files.find(f => f.id === this.state.mailFile.id)}
            renameFile={(name, onSuccess) => this.props.renameFile(this.props.authToken, this.props.info.id, this.state.mailFile.id, name, onSuccess)}
            contacts={this.props.info.contacts}
            mailFile={(recipients, note) => this.mailFile(this.props.authToken, this.props.info.id, this.state.mailFile.id, recipients, note)}
            close={() => this.setState({mailFile: null})} 
          />
        )}

        {this.state.previewFile && (
          <FilePreviewModal
            file={this.state.previewFile}
            close={() => this.setState({previewFile: null})}
          />
        )}

        {this.state.showServiceLogs ? (
          <ServiceLogModal
            logs={this.props.info.serviceLog} 
            close={() => this.setState({showServiceLogs: false})}
          />
        ) : null}
        
        <AccountReviewModal 
          data={this.props.info.account_review}
          year={this.state.accountReviewYear}
          close={() => this.setState({accountReviewYear: null})}
        />

        {this.state.showSystemReviewModal && (
          <SystemReviewModal close={() => this.setState({showSystemReviewModal: false})} />
        )}

        {this.state.resendModalReport && (
          <RecipientSelect
            key={`resend-recipients-${this.state.resendRecipients.join(',')}`}
            contacts={this.props.info.contacts || []}
            selectedRecipients={this.state.resendRecipients}
            handleRecipientSelect={(email) => {
              this.setState({
                resendRecipients: this.state.resendRecipients.includes(email)
                  ? this.state.resendRecipients.filter(r => r !== email)
                  : [...this.state.resendRecipients, email]
              });
            }}
            addNewContact={(email) => this.setState({
              resendRecipients: [...this.state.resendRecipients, email]
            })}
            submit={() => this.confirmResendReport()}
            close={() => this.setState({resendModalReport: null, resendRecipients: []})}
            loading={this.state.resendingReportId === this.state.resendModalReport.id}
            loadingMessage="Sending..."
          />
        )}

        {/* {this.props.activeQuote && (
          <QuoteGeneratorModal close={() => this.props.loadQuote(null, null)} />
        )} */}

      </div>
    ) : null
  }
}

function mapStateToProps(state, props) {
  return {
    authToken: state.authToken,
    info: state.info,
    quotableProducts: state.quotableProducts,
    activeQuote: state.activeQuote,
    loading: state.loading,
    user: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountInfo);